// extracted by mini-css-extract-plugin
export default {"large":"_1HyVa","wide":"_3g9e3","small":"_3OUqK"};